import { atom } from 'jotai';
import { atomWithLazy } from 'jotai/utils';
import { IUserDataModel } from '../../data-models/user.data-model';
import { fetchUsersByType } from '../queries/MaggieUserQueries';

const PORTCO_USER_TYPE = 'portco';

export const portcoUsersAtom = atomWithLazy<Promise<IUserDataModel[]> | IUserDataModel[]>(() =>
  fetchUsersByType(PORTCO_USER_TYPE)
);

export const activePortcoUsersAtom = atom(async (get) => {
  const users = await get(portcoUsersAtom);

  return [...users]
    .filter((u) => u.activeStatus === true)
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
});
